import type { ActionType } from "typesafe-actions";
import { getType } from "typesafe-actions";

import type { MainSearchSource } from "@/shop/api/mainSearch";
import type { IPager } from "@/shop/types/common";
import type { IPagingQuery } from "@/shop/types/searchTable";

import * as MainSearchActions from "../actions";
import { DEFAULT_PAGE_SIZE_MAIN_SEARCH_RESULTS, PAGE_SIZE_OPTIONS } from "../constants"; // TODO: unify pagesizes of this and partTreeSearch in types/common
import type { IMainSearchResultState } from "../types";

// TODO: rename in fetchSuggestionsStart etc and create separate for real MainSearch
type MainSearchActionType =
  | ActionType<typeof MainSearchActions.fetchStart>
  | ActionType<typeof MainSearchActions.fetchSuccess>
  | ActionType<typeof MainSearchActions.fetchFail>
  | ActionType<typeof MainSearchActions.clearResults>;

export function createMainSearchInitialState(source: MainSearchSource): IMainSearchResultState {
  return {
    source,
    data: null!,
    isFetching: false,
    hasError: false,
    pager: initialPager,
    query: initialQuery
  };
}

const initialPager: IPager = {
  currentPage: 1,
  numPages: 1,
  pageSize: DEFAULT_PAGE_SIZE_MAIN_SEARCH_RESULTS!,
  pageSizeOptions: PAGE_SIZE_OPTIONS
};

const initialQuery: IPagingQuery = {
  offset: 0,
  limit: DEFAULT_PAGE_SIZE_MAIN_SEARCH_RESULTS!
};

export function createMainSearchResultReducer(initialState: IMainSearchResultState) {
  return function mainSearchResultReducer(state: IMainSearchResultState = initialState, action: MainSearchActionType): IMainSearchResultState {
    if (action.meta && action.meta.collection === state.source) {
      switch (action.type) {
        case getType(MainSearchActions.fetchStart):
          return { ...state, isFetching: true, pager: initialPager };
        case getType(MainSearchActions.fetchFail):
          return { ...state, isFetching: false, hasError: true };
        case getType(MainSearchActions.fetchSuccess):
          return {
            ...state,
            isFetching: false,
            data: action.payload,
            pager: { ...state.pager },
            query: { ...state.query, ...action.meta.query }
          };
        case getType(MainSearchActions.clearResults):
          return { ...createMainSearchInitialState(action.meta.collection) };
        default:
          return state;
      }
    } else {
      return state;
    }
  };
}
